import Button from "react-bootstrap/Button";
import Modal from 'react-bootstrap/Modal';
import {useState} from "react";

export default function ResetButton({onClick}) {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const handleSubmit = () => {

        handleClose()
        onClick()
    };

    return <>
        <Button style={{position: 'fixed', bottom: "10%", right: "2%"}} variant={"danger"} className="btn-voorbrief-reset"
                onClick={handleShow}>Reset</Button>
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Modal heading</Modal.Title>
            </Modal.Header>
            <Modal.Body>Weet je zeker dat je de voorbrief wilt resetten?</Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Annuleren
                </Button>
                <Button variant="danger" onClick={handleSubmit}>
                    Reset
                </Button>
            </Modal.Footer>
        </Modal>
    </>
}